import React from 'react';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';
import Image from 'next/image';

type PageProps = {
    list: { title: string; description: string }[];
};

const Result: React.FC<PageProps> = ({ list }) => {
    return (
        <div className="skills-result">
            <FullWrapper isMargin={false}>
                <div className="skills-resultWrapper">
                    <div className="skills-resultTitle">Результаты</div>
                    <div className="skills-resultInner">
                        <div className="skills-resultLeft">
                            <div className="skills-resultParagrafList">
                                <div className="skills-resultParagraf">
                                    SkillsTeam помогает повысить эффективность управления
                                    персоналом, заменяя ручные процессы автоматизированными
                                    решениями, и&nbsp;позволяет сосредоточиться
                                    на&nbsp;стратегическом развитии.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="skills-resultSubtitle">
                        За&nbsp;первые 4&nbsp;месяца запуска продукта
                    </div>
                </div>
            </FullWrapper>
            <FullWrapper isMargin={false}>
                <div className="skills-resultWrapper">
                    <div className="skills-resultList">
                        {list &&
                            list.map(item => (
                                <div className="skills-resultItem" key={item.title}>
                                    <div
                                        className="skills-resultText"
                                        dangerouslySetInnerHTML={{ __html: item.title }}
                                    ></div>
                                    <div
                                        className="skills-resultDescription"
                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                    ></div>
                                </div>
                            ))}
                    </div>
                </div>
            </FullWrapper>
            <div className="skills-resultGrade">
                <FullWrapper isMargin={false}>
                    <div className="skills-resultWrapper">
                        <div className="skills-resultGradeBlock">
                            <div className="skills-resultGradeContent">
                                <div className="skills-resultGradeMainTitle">
                                    Возможности системы грейдов
                                </div>
                                <div className="skills-resultItem">
                                    <Image
                                        src="/images/pic/skills-team/frame.png"
                                        alt="cloud system"
                                        width={1277}
                                        height={570}
                                        className="skills-resultImg"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </div>
            <FullWrapper isMargin={false}>
                <div className="skills-resultWrapper">
                    <div className="skills-resultInner">
                        <div className="skills-resultLeft">
                            <div className="skills-resultParagrafList">
                                <div className="skills-resultParagraf">
                                    SkillsTeam эффективно решает &laquo;боли&raquo;, с&nbsp;которыми
                                    сталкиваются диджитал-агентства: оценка компетенций
                                    на&nbsp;входе, эффективное распределение ресурсов
                                    на&nbsp;проектах, планирование обучения сотрудников
                                    и&nbsp;повышение квалификации команды, мотивация
                                    и&nbsp;удержание ценных специалистов.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Result;
